"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "./tags.model";
export let ApplicationAccountItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.head_image = "";
    this.name = "";
  }
};
ApplicationAccountItemModel.model = "app.account.service";
ApplicationAccountItemModel = __decorateClass([
  Annotation.ModelMeta
], ApplicationAccountItemModel);
export let ApplicationItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.icon = "";
    this.name = "";
    this.tags = new Array();
    this.description = "";
    this.subscribe = false;
    this.marks = new TagsModel();
  }
};
ApplicationItemModel.model = "market.app.item";
ApplicationItemModel = __decorateClass([
  Annotation.ModelMeta
], ApplicationItemModel);
export let ApplicationDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.created_time = 0;
    this.updated_time = 0;
    this.name = "";
    this.provider = "";
    this.icon = "";
    this.description = "";
    this.detail_intruduction = "";
    this.release_version = "";
    this.lang = "";
    this.lang_param = "";
    this.router_url = "";
    this.subscribe = false;
    this.tags = new Array();
    this.authorized = false;
    this.marks = new TagsModel();
    this.auth_user_size = 0;
  }
};
ApplicationDetailModel.model = "market.app.item";
ApplicationDetailModel = __decorateClass([
  Annotation.ModelMeta
], ApplicationDetailModel);
export let AuthorizationUsersModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.message = "";
    this.result = {
      all_user: new Array(),
      authorization_user: new Array()
    };
  }
};
AuthorizationUsersModel.model = "operation";
AuthorizationUsersModel = __decorateClass([
  Annotation.ModelMeta
], AuthorizationUsersModel);
export let AuthorizationUsersBaseModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
    this.account = "";
  }
};
AuthorizationUsersBaseModel.model = "sub_account";
AuthorizationUsersBaseModel = __decorateClass([
  Annotation.ModelMeta
], AuthorizationUsersBaseModel);
